import { render, staticRenderFns } from "./sbar.vue?vue&type=template&id=b89f7c14&scoped=true&"
import script from "./sbar.vue?vue&type=script&lang=js&"
export * from "./sbar.vue?vue&type=script&lang=js&"
import style0 from "./sbar.vue?vue&type=style&index=0&id=b89f7c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89f7c14",
  null
  
)

export default component.exports